import { render, staticRenderFns } from "./TypePrototypeExistingTable.vue?vue&type=template&id=54c78e82&"
import script from "./TypePrototypeExistingTable.vue?vue&type=script&lang=js&"
export * from "./TypePrototypeExistingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports